import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';
import {FormattedMessage} from 'react-intl';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import BoltIcon from '@mui/icons-material/Bolt';

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1200,
    padding: '12px 16px',
    paddingBottom: 'calc(12px + env(safe-area-inset-bottom, 0px))',
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.1)',
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    width: '100%',
    maxWidth: 600,
    margin: '0 auto',
    padding: '14px 20px',
    borderRadius: 30,
    border: 'none',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  primary: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 700,
    fontFamily: 'Ploni, Arial, sans-serif',
  },
  secondary: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 400,
    fontFamily: 'Ploni, Arial, sans-serif',
    opacity: 0.9,
  },
}));

const FloatingHarHabituchCta = ({onClick}) => {
  const {classes} = useStyles();
  const trigger = useScrollTrigger({threshold: 100, disableHysteresis: true});

  return (
    <div
      className={classes.root}
      style={{transform: trigger ? 'translateY(0)' : 'translateY(100%)'}}
    >
        <button
          type='button'
          className={classes.button}
          onClick={onClick}
        >
          <BoltIcon style={{fontSize: 22}} />
          <div className={classes.content}>
            <span className={classes.primary}>
              <FormattedMessage id='docCollection.floatingCta.primary' />
            </span>
          </div>
        </button>
      </div>
  );
};

FloatingHarHabituchCta.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default FloatingHarHabituchCta;
